const translations = {
    "status": "success",
    "data": {
        "lang": "he_IL",
        "app": "hotel",
        "translation": {
            "crud": {
                "updatedSuccessfully": "עודכן בהצלחה",
                "validationFailed" : "Validation failed",
                "fieldRequired":"שדה נדרש",
                "operationError" : "Error occurred",
                "emptyList" : "No Data Found",
                "failToLoad" : "Error occurred on loading",
                "modelNotFound" : "Not Found",
            },
            "updateCard": {
                "payment_failed_please_update_card": "Payment failed - please update card",
                "open_the_payment_form": "Open the payment form",
            },
            "auth": {
                authTitle: "הזדהות באמצעות ת.ז וטלפון נייד",
                verify: "אמת קוד",
                id: "תעודת זהות",
                idPlaceholder: "הזן את תעודת הזהות שלך",
                idPlaceholderError: "אנא הזן את תעודת הזהות שלך",
                idDigits: "תעודת הזהות חייבת להכיל 9 ספרות",
                phone: "טלפון",
                phonePlaceholderError: "אנא הזן את מספר הטלפון שלך",
                phoneDigits: "מספר הטלפון חייב להכיל 10 ספרות",
                phonePlaceholder: "הזן את מספר הטלפון שלך",
                send: "שלח קוד",
                authModalTitle: "אימות עם תעודת זהות וטלפון נייד",
                loginLoaeder: "מתבצעת כניסה...",
                loginError: "הכניסה נכשלה. אנא נסה שוב.",
                otpLoader: "מאמת קוד חד-פעמי...",
                loginSuccess: "התחברת בהצלחה",
                otpError: "אימות הקוד נכשל. אנא נסה שוב.",
                otpStartOver: "לא קיבלת קוד? התחל מחדש"

},
            "upgradePlan": {
                "general": {
                    "upgrade_plan": "שדרג עכשיו!",
                    "upgrade_plan_to_regular": "שדרג ל Agent360 ותוכל לקבל גישה לכלל המוצרים - טיסות סדירה, מלונות ואטרקציות!",
                    "upgrade_plan_to_pro": "שדרג לתוכנית PRO קבל אתר משלך, ובנה את העסק בצורה איכותית ומקצועית!",
                  },
                "regular": {
                    "title" : "שדרג עכשיו וקבל גישה למוצרי Agent 360 !",
                    "benefits_title_text": "כרגע אתה מחובר לחבילה Agent 360 Light, במידה ותשדרג תוכל לקבל",
                    "text_1": "מוצרי סיטונאות סקיי 360",
                    "text_2": "מלונות לכל היעדים בעולם",
                    "text_3": "טיסות סדירות ו Low Cost",
                    "text_4": "אטרקציות בכל העולם",
                    "button_text": "שדרג עכשיו ל Agent 360 !",
                },
                "pro": {
                    "title" : "שדרג עכשיו וקבל אתר לעסק שלך עם מיתוג מלא !",
                    "benefits_title_text": "בחבילת SKY 360 Pro תוכל להנות מ",
                    "text_1": "אתר עם דומיין ייחודי שלך ",
                    "text_2": "מיתוג העסק - לוגו וצבעים לאתר ",
                    "text_3": "קידום חבילות וטיסות באתר לפי יעדים ",
                    "text_4": "כל ההזמנות שיסגרו יהיו שייכות לסוכנות שלך!",
                    "button_text": "שדרג עכשיו ל Pro !",
                },
            },
            "contactUs": {
                "requestForQuotation":"בקשה להצעת מחיר",
                "problemWithExistingOrder":"בעיה בהזמנה קיימת",
                "customerService":"שירות לקוחות",
                "other":"אחר",
                "messageReceivedSuccessfully":"ההודעה נשלחה בהצלחה",
                "email": "אימייל",
                "phone": "טלפון",
                "fullName": "שם מלא",
                "writeUsMessage": "כתבו לנו הודעה",
                "send": "שלח",
                "phoneRequired": "נא להזין מספר טלפון",
                "emailRequired": "נא להזין כתובת אימייל",
                "fullNameRequired": "נא להזין שם מלא",
                "messageRequired": "נא להזין הודעה",
                "nameMinLength": "השם חייב להכיל לפחות 2 תווים",
                "emailInvalid": "נא להזין כתובת אימייל תקינה",
                "subjectRequired": "נא לבחור נושא",
                "selectSubject": "בחר נושא",
                "messageMin": "ההודעה חייבת להכיל לפחות 10 תווים",
                "aboutUs":'עלינו'
            },
            "cart": {
                "addToCart": "הוסף לסל",
                "select": "בחר",
            },
            "customerSupport": {
                "customerService": "שירות לקוחות",
                "sendMessageAndGetNotified": "שלחו לנו הודעה ונציג יחזור אליכם בהקדם",
                "callUs": "צלצלו אלינו - ",
            },
            "roomInfo": {
                "info": "תאור החדר",
                "viewAllThePhotos": "צפו בכל התמונות",
                "roomSize": "מ״ר - גודל חדר",
                "peopleInTheRoom": "אנשים בחדר",
                "doubleBed": "מיטה זוגית",
                "flights":"טיסות",
            },
            "conceptsList":{
                "conceptsListTitle":"חבילות הנופש שלנו, מהיום רוכשים מלון עם אטרקציות!",
                "includesActivities":"אטרקציות מתנה",
                "includesActivity":"כולל אטרקציה מתנה",
                "includeInPackage":"החבילה כוללת",
                "transfer": "כולל העברות",
                "includesTransfer": "כולל העברות",
                "transferContent":"העברות הלו״ש במחיר החבילה",
                "baseBoard": "בסיס אירוח",
                "autoApprove": "באישור מיידי",
                "airways": "חברת תעופה",
                "flightFrom": "טיסה הלוך",
                "flightBack": "טיסה חזור",
                "toOrder": "להזמנה",
                "nights":"לילות",
                "numberOf": "מספר",
                "noPackagesFound":"לא נמצאו חבילות",
                "moreDeals":"אופציות נוספות",
                "pricePerPerson":"תוספת לאדם",
            },
            "wallet":{
                future: "יהלומים עתידיים",
                creditCard:"כרטיס אשראי",
                cancel: "ביטול",
                forConfirmationRedemption: "האם אתה בטוח שברצונך לממש את היהלומים?",
                TotalDiamondsYouWillReceive: "סך כל היהלומים שייצברו",
                max: "מקסימום",
                currentOrderTotal: "סכום ההזמנה הנוכחית",
                MaximumRedeemable: "מקסימום ניתן למימוש:",
                UseMax: "השתמש במקסימום",
                Apply: "החל",
                Applying: "מוחל...",
                RedeemDiamonds: "ממש יהלומים",
                RemainingDiamonds: "יהלומים שנותרו",
                DiscountedValue: "ערך לאחר הנחה",
                RedeemedAmount: "סכום שמומש",
                Redeemed: "מומש",
                totalValue: "ערך כולל",
                diamondsRate: "1 יהלום = 1 ₪",
                availableDiamonds: "יהלומים זמינים",
                diamondBalance: "יתרת יהלומים",
                discount: "הנחה",
                Subtotal: "סכום ביניים",
                paymentDetails: "תשלום באמצעות",
                totalPayment: "תשלום כולל:",
                "wallet": "ארנק",
                "walletTransactions": "עסקאות ארנק",
                "walletBalance": "יתרת ארנק",
                "diamonds": "יהלומים",
                "diamondsAreAvailableAtYourDisposal": "יהלומים זמינים לרשותך",
                "paymentWithDiamonds": "תשלום ביהלומים",
                "returnToOrderManagement": "חזרה לניהול הזמנות",
                "reserve": "שמירה",
                "finalize": "סיום",
                "release": "שחרור",
                "partialRealization": "מימוש חלקי",
                "fullRealization": "מימוש מלא",
                "selectNumberOfDiamondsForPartialUse": "בחר מספר יהלומים לשימוש חלקי",
                "useAllTheDiamondsIHave": "שימוש בכל היהלומים שיש לי",
                "save": "שמירה",
                "confirm": "אישור",
                "forConfirmation": "לאישור",
                "totalAgentFee": "סך עמלת סוכן",

                "dynamicLabels": {
                    'availableDiamondsForPayment': `יש לך #{amount} יהלומים זמינים לתשלום, בשווי #{price}`,
                    'XOfDiamondsWorthY': `#{amount} יהלומים, בשווי #{price}`,
                    'totalDiamondsYouHaveAccumulatedOverTheLast12MonthsAsOfToday': `סך היהלומים שצברת במהלך 12 החודשים האחרונים נכון להיום`,
                  },
            },
            "viewFlight":{
                "sameRates": "מחירים זהים",
                "pleaseSelectDestinationAirport": "בחר שדה תעופה ",
                "noNearbyAirportFound": "לא נמצא שדה תעופה קרוב. אנא חפש שדה תעופה וודא שהוא נמצא בקרבת המלון",
                "chooseAirportYouWantToArrive": "בחר נקודת מגישה",
                "chooseAirportYouWantToArriveDescription": "נא לבחור נקודת מגישה קרובה למלון",
                "noFlightsForSelectedDatesLocationPassengers": "אין טיסות זמינות לתאריכים/מיקום/נוסעים שנבחרו",
                "updateAirport": "החלף שדה תעופה",
                "flightFrom": "טיסה הלוך",
                "flightChange": "החלף טיסה",
                "totalChange": "סה״כ למחיר חבילה",
                "noFlightsAvailableForSelectedDates": "אין טיסות זמינות לתאריכים שנבחרו, אנא בחר תאריכים אחרים",
                "show_tickets_with_different_fare_combinations": "הצג סוגי כרטיס עם הלוך חזור שונה",
                "ticketFare":"כרטיס",
                "ticketInfo":"פירוט כרטיס",
                "termsAndConditions": "תנאים והגבלות",
                "ifTicketIncludeSeat": "אם הכרטיס כולל מושב - הלקוח יצטרך לבחור אותו באתר חברת התעופה",
                "inCaseOfChange": "במקרה של שינוי - הלקוח יצטרך לשלם תוספת אם הכרטיס המעודכן יקר יותר, כמו כן ישנה עמלת שירות נוספת בהתאם לתנאי האתר והשירותים",
                "inCaseOfCancellation": "במקרה של ביטול - תהיה עמלת שירות נוספת בהתאם לתנאי האתר והשירותים",
                "allFares":"אופציה לבחירת סוג כרטיס",
                "allFaresComment1":"שים לב שבמידה והכרטיס ניתן לשינוי או ביטול - ישנה עלות עבור דמי טיפול - יש לעיין בתקנון",
                "allFaresComment2":"הושבה, בחירת ארוחה ועוד תוספת ניתן לממש רק באתר חברת התעופה לאחר הזמנה",
                "fareChangedSuccessfully":"מחיר הנסיעה השתנה בהצלחה",
                "openFares":"תעריפים פתוחים",
                "selectedFare":"החלף סוג כרטיס ",
                "error4305Title":"אופס, אזלו המקומות לטיסה",
                "error4305Content":`אנו מתנצלים, אך כנראה שנגמרו המקומות להצעה זו ולכן אין באפשרותנו להתקדם לרכישה.
                הנך מועבר לעמוד הראשי.`,
                "TC":"תנאים",
                "flights":"טיסות",
                "title":"הטיסה הנבחרת, ודאו פרטים והמשיכו לתשלום",
                "addBaggage":"הוסף מזוודה",
                "closeAddBaggage":"הסתר אופציות",
                "addTrolly":"הוסף טרולי",
                "somethingWetWrong":"משהו השתבש",
                "suitcasePrice":"מחיר מזוודה",
                "trollyPrice":"מחיר טרולי",
                "totalPerPassenger":"סך הכל לנוסע",
                "search": "חיפש",
                "updatePassengers":"עדכן כמות נוסעים",
                "seating":"הושבה",
                "cancelation":"ביטול כרטיס",
                'meal':"ארוחות",
                'trolly':"תיק יד",
                'suitcase':"מזוודה",
                'changeFlight':"שינוי כרטיס",
                "extension":"תוספת",
                "totalToBePaid":"סה״כ לתשלום",
                "choose":"בחרו",
                "checkAmenities":"לבדוק מתקנים",
                "description":"תיאור",
                "amenityType":"סוג תוספת",
                "fullInfo":"מידע מלא",
                "flightFromAmenities":"טיסה מהשירותים",
                "flightBackAmenities":"שירותי טיסה חזרה",
                "BAGGAGE": "מטען",
                "2 CHECKED BAGS UP TO 32KG EACH": "2 תיקי מטען מסומנים עד 32 ק״ג כל אחד",
                "2 CABIN BAGS UP TO 8KG": "2 תיקי תא הנוסעים עד 8 ק״ג",
                "BRANDED_FARES": "כרטיסים ממותגים",
                "STANDARD SEAT RESERVATION": "הזמנת מושב סטנדרטי",
                "MILEAGE ACCRUAL": "צבירת נקודות",
                "MEAL": "ארוחה",
                "SNACK": "חטיף",
                "COMPLIMENTARY FOOD AND BEV": "אוכל ושתייה ללא תשלום",
                "ENTERTAINMENT": "בידור",
                "MAGAZINES / NEWSPAPER": "מגזינים / עיתונים",
                "LOUNGE": "טרקלין",
                "LOUNGE ACCESS": "גישה לטרקלין",
                "TRAVEL_SERVICES": "שירותי נסיעות",
                "PRIORITY BAGGAGE": "תיקי עדיפות",
                "PRIORITY CHECK IN": "מעבר מהיר צ'ק אין",
                "PRIORITY SECURITY": "מעבר מהיר ביטחון",
                "PRIORITY BOARDING": "מעבר מהיר עלייה למטוס",
                "IN FLIGHT ENTERTAINMENT": "בידור בטיסה",
                "CHANGEABLE TICKET": "שינוי כרטיס",
                "BASIC SEAT": "מושב בסיסי",
                "PRE_RESERVED_SEAT": "מושב שמור מראש",
                "PRIVACY SEAT BUSINESS CLASS": "מושב פרטיות מחלקת עסקים",
                "CHANGE BEFORE DEPARTURE": "שינוי לפני היציאה",
                "CHANGE AFTER DEPARTURE": "שינוי לאחר היציאה",
                "REFUND BEFORE DEPARTURE": "החזר לפני היציאה",
                "REFUND AFTER DEPARTURE": "החזר לאחר היציאה"

            },
            "room": {
                "roomSize": "גודל החדר",
                "bedType": "סוג מיטה",
                "breakfastIncluded": "כולל ארוחת בוקר",
                "noAvailabilityOnSelectedDates": "אין זמינות לחדר זה בתאריכים הנבחרים"
            },
            "promotion": {
                "modelNotFound": "דף לא נמצא",
                "failToLoad": "לא הצלחנו לטעון את העמוד!",
            },
            "searchDatePicker": {
                'PARTICIPANTS': 'משתתפים',
                'CITY': 'עיר',
                'COUNTRY': 'מדינה',
                'EVENT_TYPE': 'סוג אירוע',
                'TOURNAMENTS': 'טורנירים',
                'VENUES': 'מיקומים',
                "events":"אירועים",
                "sportsAndEvents":"ספורט ואירועים",
                checking: "בדיקה",
                providers: "מספקים",
                keepScanning: "לחפש",
                validatePricesInRealTime: "לאמת מחירים בזמן אמת",
                foundSoFar: "נמצא עד כה",
                return: "חזרה",
                calendar: "לוח שנה",
                cubes: "קוביות",
                requiredFields: "אנא מלאו את כל השדות הנדרשים: יעד, יציאה ותאריכים כדי להציג את התוצאות.",
                otherDeparture:"בחר יציאה אחרת",
                departure: "יציאה",
                "freeCancellationTooltipText": "הביטול החופשי תקף רק לחדרי המלון",
                "dynamicPackages": "טיסה + מלון באישור מיידי!",
                "includeEvents": "כלול אירועים",
                "includeFullPackage": "כלול חבילה מלאה",
                "package_hotel_flight": "חבילה (טיסה + מלון)",
                "package_hotel_flight_events": "חבילה (טיסה + מלון + אירועים)",
                "hotel_plus_flight": "מלון + טיסה",
                "hotel_plus_flight_events": "מלון + טיסה + אירועים",
                "searchHotelsByNameTitle": "חיפוש לפי שם מלון ליעד שנבחר",
                "choose_packages_according_to": "חבילות לפי סוג",
                "tech_stops": "עצירות טכניות",
                "freePlanFlightSearchFooterText": "החבילה החינמית מאפשרת לחפש טיסות צ׳רטר בלבד! מעוניין בטיסות סדירות לכל העולם",
                "clickHere": "לחץ כאן",
                "approveSelection": "אישר נוסעים",
                "attractions":"אטרקציות",
                "attractions_type":"סוגי אטרקציות",
                "room":"חדר",
                "mapView": "הצג תוצאות במפה",
                'addRoom':"הוסף חדר",
                "removeRoom":'להסיר חדר',
                "indirectFlight": "עם עצירות",
                "directFlightLabel": "טיסות ישירות",
                "city": "City",
                "hotel": "Hotel",
                "searchForDestination":"חפש יעד",
                "searchByDestinationAndHotel": "בחר יעד או מלון ",
                "searchHotelOrDestination": "חפש מלון או יעד",
                "noResultsForThisDate":"לא נמצא חבילות לתאריך זה",
                "searchDestination":"חפש יעד",
                "pleaseSelectDestination":"אנא בחר יעד",
                "airlineInformation":"מידע על חברת התעופה",
                "airlineCode":"קוד",
                "title":"הזמינו את חופשת החלומות שלכם",
                "hotelOnly":"חיפוש חופשה בתאריכים",
                "hotelWithFlight":"חיפוש חופשה כולל טיסה",
                "oneWay":"כיוון אחד",
                "roundTrip":"הלוך ושוב",
                "selectDate":"בחרו תאריכים",
                "startDate":"תאריך התחלה",
                "endDate":"תאריך סיום",
                "flights":"חיפוש טיסות",
                "packages":"חבילות נופש",
                "hotels":"מלונות בחול",
                "israelPackage":"חופשה בארץ",
                "specialPackage":"חבילות מיוחדות",
                "passengers":"נוסעים",
                "adults":"מבוגרים",
                "adult":"מבוגר",
                "child":"ילד",
                "children":"ילדים",
                "infant":"תינוק",
                "infants":"תינוקות",
                "infantsWarningMessage":"תינוק צריך להיות פחות משנתיים מיום הטיסה הלוך וחזור",
                "select":"בחר",
                "noResults":"אין תוצאות",
                "checkout":"בצע הזמנה",
                "regularPrice":"מחיר רגיל",
                "from":"מ",
                "purchase":"לִרְכּוֹשׁ",
                "selectNewFlight":"בחר טיסה חדשה",
                "search": "חיפוש",
                "rooms": "חדרים",
                "composition": "הרכבים",
                "chooseComposition": "בחרו הרכבים",
                "numberOfGuests": "כמות אורחים",
                "checkOut": "צ׳ק אאוט",
                "checkIn": "צ׳ק אין",
                "whatVacation": "איזה חופשה",
                "youWant": "אתם רוצים",
                "vacationFriendsWith": "חופשה  חברים עם",
                "familyVacation": "חופשה משפחתית",
                "romanticVacation": "חופשה רומנטית",
                "notAvailable": "אין זמינות",
                "roomAvailableDuringTheWeek": "זמינות חדרים במהלך השבוע",
                "followingDates": "תאריכים הבאים",
                "vacation":"חופשה",
                "abroad":"בחו״ל",
                "inIsrael":"בארץ",
                "destination":"כל היעדים",
                "chooseDestination":"בחרו יעדים",
                "findDreamVacation":"חפשו את החופשה המושלמת בקליק.",
                "searchResTitle":"בחרו את החבילה המתאימה עבורכם",
                "directFlight":"טיסה ישירה ",
                "stop_1": "עצירה אחת",
                "stops": "עצירות",
                "activeFlight":"הטיסה מופעלת",
                "flightSearch":"חיפוש טיסה",
                "nights":"לילות",
                "until":"עד תאריך",
                "date":"תאריך",
                "untilYouSearchForFlightDate":"עד חיפוש טיסות תאריך",
                "destinationFrom":"המראה",
                "packageSearch":"חיפוש חבילה",
                "destinationTo":"נחיתה",
                "selectDestination":"בחר יעד",
                "checkHotel":"מעבר להזמנה",
                "noRating": "ללא דירוג",
                "toOrder":"להזמנה",
                "selectAgain": "בחר מחדש",
                "selectFlight": "בחר טיסה",
                "reselectFlight": "בחר טיסות מחדש",
                "flightCanBeReSelectedNextPage": "יהיה ניתן להחליף טיסה בהעמוד החבילה",
                "flightSelectedSuccessfully": "טיסה נבחרה בהצלחה",

                "dynamicFlight":"בחרו את הטיסות בעצמכם",
                "bundle": "טיסות מוגדרות מראש",
                "freeCancelation":"ביטול חופשי",
                "trollyIsIncluded":"טרולי כלול",
                "trollyIsNotIncluded":"ללא טרולי",
                "suitcaseIsIncluded":"מזוודה כלולה",
                "suitcaseIsNotIncluded":"ללא מזוודה",

                "partially_operated_by_airlines": "מופעלת חלקית ע״י",
                "operated_by_airlines": "מופעלת ע״י",
                "connect_in_airport": "עצירה בשדה ",
                "arrives": "הגעה",
                "journey_duration": "משך המסלול",
                "short_wait": "עצירה קצרה",
                "long_wait": "עצירה ארוכה",
                "flight_number": "מספר טיסה",
            },
            "specialDeal": {
                "closeTheDeal": "סגרו את הדיל ›",
                "endsIn": "מסתיים בעוד",
                "specialDealForTheWeekend": "דיל מיוחד לסופ״ש",
                "from": "מתאריך",
                "until": "עד תאריך"
            },
            "footer": {
                "backToTop": "חזור למעלה",
                "allRightsReserved": " © כל הזכויות שמורות, אין להעתיק תוכן מהאתר ללא רשות.",
                "developBy": "by SKY 360 Technology",
                "thePurchaseOnTheWebsiteIsSecure": "הרכישה באתר מאובטחת.",
                "talkToUs": "איך מדברים איתנו?",
                "address": "כתובת",
                "phone": "טלפון",
                "whatsapp": "וואטסאפ",
                "phoneAndWhatsapp": "טלפון או בוואטסאפ",
            },
            "newsletter": {
                "title": "הירשמו לניוזלטר שלנו",
                "subtitle": "קבלו גישה מוקדמת למבצעים והמלצות ליעדים",
                "placeholder": "השאירו מייל וקבלו גישה לדילים לפני כולם",
                "subscribe": "הירשמו",
                "pleaseEnterEmail": "אנא הזינו כתובת אימייל",
                "somethingWentWrong": "משהו השתבש. נסו שוב."
            },
            "attractionQuestions": {
                "customerInfo": "פרטי המזמיו",
                "participantsInfo": "פרטי אורח",
                "first_name": "שם פרטי",
                "last_name": "שם משפחה",
                "email_address": "אימייל",
                "phone_number": "מס טלפון",
                "pickup_location": "כתובת איסוף",
                "height_in_centimeters": "גובה בסנטימטר",
                "weight_in_kilograms": "משקל בק״ג",
            },
            "attractions":{
                "showingMoreResults": "מציג תוצאות נוספות",
                "noMoreResults": "אין יותר תוצאות",
                "NoResultsMatchedTheFilterValues": "אין תוצאות תואמות לערכי הסינון",
                "inclusions": "כלול",
                "exclusions": "לא כלול",
                "overviewOfTheTrip.":"סקירה כללית על הטיול",
                "immediateConfirmation":"אישור מיידי!",
                "pricePerPerson": "מחיר לאדם",
                "totalForXXXPeople":"סה״כ ל-XXX אנשים",
                "toOrder":"להזמנה",
                "freeCancelation":"הזמינו עכשיו עם ביטול בחינם!",
                "showAll":"פתח הכל",
                "days": "ימים",
                "rating": "דירוג",
                "supplier": "ספק האטרקציה",
                "location": "מיקום",
                "pricePerPersonFrom": "מחיר לאדם החל מ-",
                "selectDatesAndTravelers": "בחרו תאריכים וכמות ומטיילים",
                "bookNowWithFreeCancellation": "הזמינו עכשיו עם ביטול בחינם!",
                "updateSearch": "עדכון חיפוש",
                
                'activities-health-wellness-spas': 'ספא',
                'activities-action-entertainment-shows-events': 'הצגות ואירועים',
                'activities-nature-outdoors-zoos-aquariums': 'גני חיות ואקווריומים',
                'activities-food-drink': 'אוכל ושתייה',
                'activities-action-entertainment-shopping': 'קניות',
                'activities-nature-outdoors-tickets-passes': 'כרטיסים ומעברים',
                'activities-action-entertainment-rentals-rides': 'השכרות ונסיעות',
                'activities-transportation': 'תחבורה',
                'activities-culture-shows-events': 'הצגות ואירועים',
                'activities-nature-outdoors': 'טבע ושטח פתוח',
                'activities-tours-by-theme-shopping-tours': 'סיורי קניות',
                'activities-workshops-classes-sport-lessons': 'שיעורי ספורט',
                'activities-action-entertainment-tickets-passes': 'כרטיסים ומעברים',
                'activities-workshops-classes-music-dance': 'מוזיקה וריקוד',
                'activities-food-drink-workshops-classes': 'סדנאות ושיעורים',
                'activities-health-wellness-relaxation': 'הרפיה',
                'activities-tours-by-theme-food-drink-tours': 'סיורי אוכל ושתייה',
                'activities-workshops-classes': 'סדנאות ושיעורים',
                'activities-health-wellness-beauty-treatments': 'טיפולי יופי',
                'activities-action-entertainment-water': 'מים',
                'activities-workshops-classes-arts-crafts': 'אמנות ומלאכת יד',
                'activities-tours-by-theme': 'סיורים לפי נושא',
                'activities-action-entertainment-land': 'יבשה',
                'activities-tours-by-theme-sport-tours': 'סיורי ספורט',
                'activities-culture': 'תרבות',
                'activities-tours-by-theme-walking-tours': 'סיורי הליכה',
                'activities-health-wellness-alternative-medicine': 'רפואה אלטרנטיבית',
                'activities-tours-by-theme-art-culture-tours': 'סיורי אמנות ותרבות',
                'activities-workshops-classes-cultural-immersion': 'הטמעה תרבותית',
                'activities-health-wellness': 'בריאות ורווחה',
                'activities-nature-outdoors-air-activities': 'פעילויות אוויריות',
                'activities-tours-by-theme-luxury-tours': 'סיורי יוקרה',
                'activities-tours-by-theme-historical-heritage-tours': 'סיורי מורשת היסטוריים',
                'activities-culture-art-culture-tours': 'סיורי אמנות ותרבות',
                'activities-action-entertainment-air': 'אוויר',
                'activities-tours-by-theme-nature-wildlife-tours': 'סיורי טבע וחיות בר',
                'activities-tours-by-theme-discovery-tours': 'סיורי גילוי',
                'activities-nature-outdoors-wildlife-nature-observation': 'תצפיות טבע וחיות בר',
                'activities-action-entertainment': 'פעולה ובידור',
                'activities-tours-by-theme-museum-exhibition-tours': 'סיורי מוזיאון ותערוכות',
                'activities-workshops-classes-food-drink': 'אוכל ושתייה',
                'activities-tours-by-theme-virtual-tours': 'סיורים וירטואליים',
                'activities-tours-by-theme-special-tours': 'סיורים מיוחדים',
                'activities-nature-outdoors-land-activities': 'פעילויות שטח',
                'activities-transportation-rentals-rides': 'השכרות ונסיעות',
                'activities-nature-outdoors-water-activities': 'פעילויות מים',
                'activities-food-drink-restaurants-bars': 'מסעדות ובר',
                'activities-food-drink-food-drink-tours': 'סיורי אוכל ושתייה',
                'activities-no-category': 'ללא קטגוריה',
                'activities-health-wellness-retreats': 'ריטריטים',
                'activities-action-entertainment-sport-lessons': 'שיעורי ספורט',
                'activities-tours-by-theme-self-guided-tours': 'סיורים עצמאיים',
                'activities-action-entertainment-multi-adventure-games': 'משחקי הרפתקה מרובה',
                'activities-food-drink-tickets-passes': 'כרטיסים ומעברים',
                'activities-tours-by-theme-night-tours': 'סיורי לילה',
                'activities-culture-tickets-passes': 'כרטיסים ומעברים',
                'activities-transportation-transfers': 'העברות',
                "hours":"שעות",

                ages_between_min_max_range: `Ages Between {min_max_range}}`,
                sum_price_amount: `Sum Price: {amount}`,
            },
            "sportsAndEvents": {
                "dateNotFinal": "תאריך לא סופי",
                "dateAndTimeAreSubjectToChange": "תאריך ושעה עלולים להשתנות",
                "onlyAFewTicketsLeft": "רק כמה כרטיסים נותרו",
                "pricePerTicket": "מחיר לכרטיס",
                "reselectSeating": "איפוס סידור הישיבה",
                "sportsAndEvents": "ספורט ואירועים",
                "noTitle": "אירוע",
                "comingSoon": "בקרוב!",
                "noTicketsAvailable": "אין כרטיסים זמינים",
                "selectTickets": "בחר כרטיסים",
                "notifyMe": "הודע לי",
                "notifyMeDescription": "הזן את כתובת האימייל שלך כדי לקבל התראה כאשר כרטיסים יהיו זמינים",
                "notifyMeEmailPlaceholder": "הזן את כתובת האימייל שלך",
                "notifyMeSubmit": "הודע לי",
                "notifyMeSuccess": "תקבל התראה כאשר כרטיסים יהיו זמינים",
                "notifyMeError": "שליחת ההתראה נכשלה. אנא נסה שוב.",
                "notifyMeEmailRequired": "אנא הזן את כתובת האימייל שלך",
                "notifyMeEmailInvalid": "אנא הזן כתובת אימייל תקינה",
                "tournament": "טורניר",
                "participants": "משתתפים",
                "eventType": "סוג אירוע",
                "vipPackage": "חבילת VIP",
                "hold24Hours": "שמירה ל-24 שעות",
                "instantConfirmation": "אישור מיידי",
                "viewOnMap": "הצג במפה",
                "selectQuantity": "בחר כמות",
                "avenue": "שדרה",
                "venue": "מקום",
                "city": "עיר",
                "country": "מדינה",
                "state": "מדינה",
                "zip": "מיקוד",
                "latitude": "קו רוחב",
                "longitude": "קו אורך",
                "whereWillISit": "איפה אשב?",
                "seatingArrangements": "סידורי הישיבה",
                "seatingInPairs": "ישיבה בזוגות",
                "seatingInPairsDescription": "אנו מתחייבים לשבת אתכם בזוגות (שניים ביחד) אלא אם קטגוריית הכרטיס מציינת אחרת.",
                "seatingInPairsNote": "שימו לב: באצטדיונים מסוימים (בעיקר קאמפ נואו של ברצלונה וסנטיאגו ברנבאו של ריאל מדריד) \"ישיבה בזוגות\" כוללת מושבים צמודים באלכסון או בניצב.",
                "seatingThreeTogether": "ישיבה של שלושה ביחד או יותר",
                "seatingThreeTogetherDescription": "כאשר אתה צריך שלושה כרטיסים או יותר נעשה כמיטב יכולתנו להושיב אתכם ביחד; עם זאת, איננו יכולים להבטיח זאת.",
                "seatingThreeTogetherNote": "אם אתם חייבים לשבת ביחד, אנא בדקו זמינות עם צוות שירות הלקוחות שלנו, בטלפון או בדוא״ל. ברוב המקרים נוכל לאשר בקשה ספציפית או להציע פתרון חלופי.",
                "homeFansOrAwayFans": "אוהדי הבית או האורחים",
                "homeFansDescription": "כל הכרטיסים הם למחלקת הבית, אלא אם צוין אחרת (\"מחלקת האורחים\").",
                "homeFansBehaviorCode": "על פי קודי ההתנהגות של המארגן, אסור לכם לעודד את קבוצת האורחים או ללבוש צבעי קבוצת אורחים. מומלץ גם למשתתפים ללבוש בגדים בצבעים ניטרליים אם אינם תומכים בקבוצת הבית. אי ציות לכללים אלה עשוי להתפרש כפרובוקציה ועלול להוביל לגירוש מהאצטדיון.",
                "neutralVenueNote": "המפרטים לעיל אינם חלים על משחקים שמשוחקים באצטדיון ניטרלי (כמו גמר ליגת האלופות, גמר הליגה האירופית, גמר גביע האנגלי, גמר גביע הליגה או אירועי גביע העולם). אלא אם צוין אחרת, המושבים יכולים להיות ממוקמים באחד מהמקטעים, ולכן מומלץ ללבוש בגדים בצבעים ניטרליים.",
                "singleTickets": "כרטיסים בודדים",
                "singleTicketsDescription": "לפעמים אנו מציעים כרטיסים המסווגים במיוחד כ\"בודדים\".",
                "singleTicketsNote": "כרטיסים אלה הם בדרך כלל זולים יותר, אבל הם מה שהם - בודדים. אם תקנו שני כרטיסים \"בודדים\" לא תשבו ביחד.",
                "groupSeating": "ישיבה קבוצתית",
                "groupSeatingDescription": "עבור 8 כרטיסים או יותר אנא בדקו את הזמינות עבור ישיבה קבוצתית והמחיר עם צוות שירות הלקוחות שלנו, בטלפון או בדוא״ל. ישיבה קבוצתית עשויה להיות זולה יותר או יקרה יותר, בהתאם לזמינות.",
                "groupSeatingNote": "אם קטגוריית הכרטיסים שבחרת מאפשרת זאת - אתה יכול להמשיך ולבצע את ההזמנה מבלי לפנות אלינו תחילה, אך זכור, במקרה כזה נוכל להבטיח רק ישיבה בזוגות.",
                "pleaseNote": "שימו לב",
                "pleaseNoteDescription": "המידע לעיל על סידורי הישיבה הוא כללי ובדרך כלל עשוי שלא להתאים לתיאור המדויק של הכרטיס שבחרת. כאשר זמין, אנו מציגים את תרשים הישיבה הרלוונטי או מפת המקום.",
                "pleaseNoteConsult": "אנא התייעץ בו בעת בדיקת קטגוריות הכרטיסים לאירוע זה.",
                "haveMoreQuestions": "יש עוד שאלות?",
                "contactUsForInfo": "למידע נוסף אנא אל תהסס ליצור עמנו קשר",
            },
            "packages": {
                "tour": "טיול מאורגן",

                "availableSeats":"כיסאות פנויים",
                "isRoundTrip":"מחיר מזוודה לטיסה הלוך חזור * ",
                "from": "מתאריך",
                "until": "עד תאריך",
                "breakfastIncluded": "כולל ארוחת בוקר",
                "includesMassageAndSpa": "כולל מסאג׳ וספא!",
                "lastRoom": "חדר אחרון!",
                "includesTransfers": "כולל העברות",
                "includesFlights": "כולל טיסות",
                "includesEventTicket": "כולל כרטיס לאירוע",
                "includesActivities": "כולל אטרקציות",
                "nights": "לילות",
                "withoutBaggage":"ללא כבודה",
                "directFlight":"טיסה ישירה",
                "oneStop":"עצירה אחת",
                "numOfStops":"עצירות",
                "flightDetails":"פרטי הטיסות",
                "flightFrom":" from -> to ",
                "flightBack":" from -> to ",
                "hours":"שעות",
                "flightNumber":"מס׳ הטיסה",
                "returnFlight":"טיסה חזור",
                "outboundFlight":"טיסה הלוך",
                "airLine":"חברת התעופה",
                "suitcaseWeight":" הטיסה כוללת מזוודה weight ק״ג",
                "trollyWeight":"  הטיסה כוללת טרולי weight ק״ג",
                "trollyWeight2":"weight ק״ג טרולי / תיק",
                "suitcaseWeight2":"weight ק״ג מזוודה",
                "included":"כלול",
                "notIncluded":"לא כלול",
                "perPax":"לאדם",
                "addSuitcaseLater":"יהיה ניתן להוסיף בעגלה - ניהול כבודה",
                "includedActivitiesTitle":"אטרקציות וטיולים בחבילה",
                "checkAllPictures":"הצג את כל התמונות",
                "affiliateWith": "בשיתוף עם",
                "addButtonDisabledTooltip": "הזמנה מוגבלת לכמות חדרים - לא ניתן להוסיף חדר נוסף. כדי לשנות חדר יש להסיר חדר מהעגלה",
                'holidaySchedule':"לו״ז הנופש",
                "passengers":"נוסעים",
                "clickForDetails":"לחצו כאן לפרטי האטרקציה",
                "includedInPackage":"כלול בחבילה!",
            },
            "roomPricing": {
                "noRoomsAvailableForSelectedDates": "אין חדרים זמינים לתאריכים שנבחרו, אנא בחר תאריכים אחרים",
                "noRoomsAvailable": "אין חדרים זמינים לתאריכים ולאורחים שנבחרו.",
                "for": "ל",
                "addPassenger": "הוסף נוסע",
                "autoApprove": "באישור מידי",
                "pricePerPerson": "מחיר לאדם",
                "pricePerRoom": "מחיר לחדר",
                "priceForAllRooms": "מחיר לכל החדרים",
                "payOnSpot": "לתשלום במקום",
                "resort_fee": "מס תייר",
                "occupancy_tax": "מס לינה",
                "totalPrice": "מחיר לחדר ",
                "pricePerInfant": "מחיר לתינוק",
                "composition": "הרכב",
                "adultsInTheRoom": "מבוגרים",
                "children": "ילדים",
                "adults":"מבוגרים",
                "single":"מבוגר יחיד",
                "child":"ילד",
                'selectInfantCount':"בחר מרשימה",
                'infant':"תינוק",
                '1infant':"תינוק אחד",
                '2infants':"2 תינוקות",
                'infants':"תינוקות",
                "noInfants":"ללא תינוקות",
                "all_include": "הכל כלול",
                "breakfast":"ארוחת בוקר",
                "activities":"סיור לבחירה",
                "half_board":"חצי פנסיון",
                "half_board_kosher":"חצי פנסיון כשר",
                "full_board" : "פנסיון מלא",
                "sleep_only" : "לינה בלבד",
                "breakfast_kidush" : "א.בוקר וא.ערב שישי",
                "addToCard": "הוסיפו להזמנה",
                "inPackageDates": "בתאריכי החבילה",
                "chooseRoom": "בחרו סוג חדר",
                "nights": "לילות",
                "boardType":"בסיס לינה",
                "filters":"מסננים",
                "noAvailableRooms": "אין חדרים זמינים לתאריכים הנבחרים",
                "noAvailableRoomsForDates": "חדר לא זמין בתאריכים הנבחרים",
                "addInfant":"הוספת תינוק",
                "roomFacilities":"מתקני החדר",
                "show_images": "לכל תמונות החדר",

                //// UPDATE IT LATERRR
                "until": "עד",
                "no": "ללא ביטול חינם",
                "vat": "מע״מ",
                "is": "",
                "not": "לא",
                "includedInPrice": "כלול במחיר",
                "city_tax": "מס מקומי",
                "cancellation_policy": "תנאי ביטול",
                "your_local_time": "* זמן מקומי",
                "additional_price_info": "מידע נוסף",
                "policy": {
                    "freeCancallationUntil": "ביטול חינם עד לתאריך",
                    "freeCancallationUntil2": "ביטול חינם עד",
                    "cancallationBeCharged": "דמי ביטול בסך",
                    "ifYouCancelBetween": "במידה ותבטל מתאריך",
                    "ifYouCancelTill": "במידה ותבטל עד תאריך",
                    "ifYouCancelModifiedBetween": "במידה ותבטל או תשנה את ההזמנה לאחר ה ",
                    "cancelFullPrice": "ייגבו דמי ביטול מלאים",
                    "till": "עד",
                    "rateNonRefundable": "מחיר זה הוא עם דמי ביטול מלאים",
                }
            },
            "boards" : {
                "RO": "לינה בלבד",
                "BB": "ארוחת בוקר",
                "HB": "חצי פנסיון",
                "FB": "פנסיון מלא",
                "AI": "הכל כלול",
                "all-inclusive": "הכל כלול",
                "UA": "אולטרה הכל כלול",
                "UI": "אולטרה הכל כלול",
                "UAI": "אולטרה הכל כלול",
                "BF": "ארוחת בוקר בופה",
                "KB": "ארוחת בוקר כשרה",
                "KHB": "חצי פנסיון כשרה",
                "CB": "ארוחת בוקר קונטיננטלית",
                "AB": "ארוחת בוקר אמריקאית",
                "DR": "ארוחת ערב וחדר",
                "EB": "ארוחת בוקר אנגלית",
                "FT": "פנסיון מלא + טיפולים",
                "F+": "פנסיון מלא פלוס",
                "GA": "ארוחת גלה",
                "H6": "חצי פנסיון + 6 טיפולים",
                "HT": "חצי פנסיון + טיפולים",
                "IB": "ארוחת בוקר ישראלית",
                "KO": "כשר",
                "KS": "ארוחת בוקר כשרה",
                "MI": "הכל כלול מקסימום",
                "RB": "חדר וארוחת בוקר",
                "NN": "ראה את המסלול",
                "SI": "הכל כלול רך",
                "UL": "אולטרה הכל כלול",
                "half_board":"חצי פנסיון",
                "half-board":"חצי פנסיון",
                "half_board_kosher":"חצי פנסיון כשר",
                "full_board" : "פנסיון מלא",
                "full-board" : "פנסיון מלא",
                "sleep_only" : "לינה בלבד",
                "breakfast_kidush" : "א.בוקר וא.ערב שישי",
                "breakfast": "ארוחת בוקר",
                "breakfast-for-2": "ארוחת בוקר לזוג",
                "nomeal": "לינה בלבד",
                "all_include": "הכל כלול",
            },
            "activitiesTranslations": {
                "addToOrder": "הוסיפו להזמנה",
                "passenger": "לנוסע",
                "showMore": "הצג עוד",
                "addAttractionsAndTrips": "הוסיפו אטרקציות וטיולים",
                "doYouWantToAddAttractions":" רוצים להוסיף אטרקציות לחופשה שלכם?",
                "itsTime":"זה הזמן!",
                "pricePerPerson":"מחיר לנוסע",
            },
            "modal": {
                "viewAllImages": "להציג את כל התמונות",
                "galleryTitle": "גלריית תמונות",
                "cancelationTerms": "תנאי ביטול - ",
                "nameOfTheHotel": "פרטי המלון",
                "hotelInfo": "על המלון",
                "hotelWebsite": "קישור לאתר המלון",
                "showMore": "הצג את כל המידע",
                "showLess": "הסתר",
            },
            "manageBaggage":{
                'manageBaggage':"ניהול כבודה",
                "and": "ו",
                "save": "שמור",
                "purchaseIsNotSupported": "לא ניתן להוסיף לטיסה עם ספק זה",
                "baggageIsForBothFlights": "ניתן להוסיף כבודה לטיסה הלוך ושוב",
                "suitcase":"מזוודה",
                'trolly':"טרולי",
                'guest':'נוסע',
            },
            "shoppingCartTranslations":{
                localInventoryAlert:"הזמנה עם חבילה מיוחדת, כרגע לא נתמכת לצפייה - רק לתשלום",
                "dynamicPackageTitleRemark": "המחיר כולל טיסה ומלון - כל מוצר מוגדר באופן עצמאי",
                "productIsApproved": "קיבלנו אישור למוצר זה!",
                "productIsNotApproved": "מוצר זה לא אושר",
                "waitingToApprove": "מוצר זה ממתין לאישור",
                "productIsCancelled": "מוצר זה בוטל",
                "orderIsApproved": "ההזמנה אושרה!",
                "orderIsNotApproved": "ההזמנה לא אושרה!",
                "orderBeingProcessed": "ההזמנה נמצאת בתהליך אישור, נא להמתין...",
                "orderIsCancelled": "ההזמנה בוטלה!",

                'attractionPriceDescription': "מחיר כרטיס יכול להשתנות בימים מסוימים, בחירה של סוג כרטיס כמויות ועוד",
                "selectedDate": "תאריך נבחר",
                "selectADate": "בחר תאריך",
                "availableDatesBetween": "תאריכים זמינים בין",
                "Options": "אפשרויות",
                "Text": "טקסט",
                "Ticket type": "סוג כרטיס",
                "Start Time": "שעת התחלה",
                'Guide language': "שפת מדריך",
                "Pick Up Location": "מיקום איסוף",
                "Custom Pick Up Location": "מיקום איסוף מותאם אישית",
                "Drop Off Location": "מיקום הורדה",
                "Custom Drop Off Location": "מיקום הורדה מותאם אישית",
                'manageBaggage':"ניהול כבודה",
                "youCanAddGuestsOnlyUpToTheAvailableSeats":"ניתן להוסיף לסל על פי כמות המקומות הזמינים לטיסה",
                "paxExceedsAuthorizedSeats": "כמות הנוסעים עולה על כמות המקומות שמאושרים למחיר זה - יש לקחת בחשבון שההזמנה תכנס ללא אישור מיידי ושהמחיר יכול להשנות",
                "paxExceedsAvailableSeats": "כמות הנוסעים עולה על כמות המקומות הזמינה - יש לקחת בחשבון שההזמנה תכנס כממתינה לאישור הספק ושהמחיר יכול להשנות",
                "infantAdditionalPrice":"תוספת מחיר תינוק",
                "netPriceWarning":"מחיר נטו, יש להוסיף עמלה!",
                "copyOrderLink":"העתק קישור להזמנה",
                "createOrder":"שמור הצעה",
                "updateCommission":"שמור",
                "commissionNotSaved":"עמלה חדשה לא נשמרה, יש ללחץ על שמור",
                "clearCart":"לחץ להסרת הלקוח והמוצרים",
                "assignCustomer":"שיוך לקוח",
                "firstName":"שם פרטי",
                "lastName":"שם משפחה",
                "phone":"טלפון",
                "comment":"תגובה",
                "email":"אימייל",
                "wrongEmailFormat":"פורמט אימייל שגוי",
                "saveCustomer":'שמור לקוח',
                "updateCustomerTitle":"עדכון לקוח",
                "createCustomerTitle":"צור לקוח חדש",
                "asignCustomer":"שיוך לקוח",
                "sendByWhatsApp":"שלח ב WhatsApp",
                "copyText":"העתק הצעה",
                "sendBySMS":"שלח ב SMS",
                "findQuoteFor":"שלח הצעת מחיר באמצעות",
                "linkIsGive":"הצעה הינה Live ",
                "dates":"תאריכים",
                "hotelName":"שם המלון",
                "flightPrice":"מחיר טיסה",
                "suitcase":"מזוודה",
                'trolly':"טרולי",
                "passengers":"נוסעים",
                "attractionSearchFailed": "חיפוש אטרקציות נכשל",
                "searchOtherForDates": "אין זמינות, אנא חפש תאריכים זמינים אחרים",
                "cannotSearchForThePastDates": "לא ניתן לחפש תאריכים שחלפו",
                "noAvailabilityOnThisDates": "אין זמינות לתאריכים שנבחרו",
                "shoppingCartButtonTooltip":"יש לבחור הרכב ולהוסיף להזמנה",
                "totalPrice":"סה״כ לתשלום",
                "totalAgentComm":"סה״כ עמלת סוכן",
                "proceedToPayment":"המשך לתשלום",
                "placeOrder":"מעבר לרישום",
                "NoHotelWasChosenForTheVacation":" לא נבחר מלון לחופשה",
                "betweenDates":"בין התאריכים",
                "packageInformation":"פרטי החבילה",
                "rooms":"פירוט החדרים",
                "transfers":"העברות",
                "round_trip_transfers": "העברות / שאטלים למלון הלוך ושוב",
                "reg_transfers":"העברות / שאטלים למלון הלוך ושוב",
                "shuttle_transfers":"שאטלים מהגבול למלון וחזור",
                "flights":"טיסות",
                "activities":"אטרקציות",
                "shoppingCart":"סל מוצרים",
                "package":"חבילת נופש",
                "nights":"לילות",
                "inHotel":"במלון",
                "apply":"אישור",
                "promoCode":"קוד קופון",
                "yourShoppingCart":"סל הקניות שלכם",
                "isEmpty":"עדיין ריק...",
                "myVacation":"החופשה שלי",
                "showAll":"הצג הכל »",
                "beforeDiscount": "סה\"כ לפני הנחה -",
                "agentCommission": "עמלת סוכן -",
                "agentCommissionNet": "עמלת סוכן (תשלום נטו) -",
                "discountFromCode": "הנחת קוד -",
                "affiliateWith": "בשיתוף עם -",
                "tpId": "מזהה הזמנה -",
                "chargeTypeFullCC": "תשלום מלא - כולל עמלה",
                "chargeTypeNetCC": "תשלום עבור מחיר נטו",
                "chargeTypeCash": "עסקה במזומן",
                "agentCommissionPrec": "אחוז עמלת סוכן",
                "priceOff": "הנחה",
                "percentageOff": "אחוז הנחה",
                "selectedItems":"פריטים נבחרים",
                "agentOptions":"אופציות סוכן",
                "compareDisableForAgent":"ניתן להשוות מחיר כאשר יש 2 הצעות בעגלה",
                "createNewUser":"צור הצעת מחיר חדשה",
                "comparePrice":"השוואת מחירים",
                "send":"שלח הצעת מחיר",
                "profitPercentageChange": "שינוי אחוז רווח",
                "or":"או",
                "approval":"אישור",
                "profitPerPerson":"רווח לאדם",
                "grossProfitPercentage":"אחוז רווח כולל",
                "viewProduct": "לצפייה",
                "actionNotAllowed":"לא ניתן להוסיף מוצר לסל",
                "orderIsAlreadySaved":"ההזמנה שמורה וכעת לא ניתן להוסיף מוצר נוסף",
                "clickToClear":"לחץ לריקון העגלה",
                "roomsByRequestSubjectOfHotelAvailability":"לא ניתן להוסיף חדדר מאותו סוג, נא בחר חדר מסוג אחר",
                "roomApprovalIsSubjectToRoomAvailability":"אישור החדר תלוי בזמינות החדר",
                "unableToAddRoomToSamePackage": "לא ניתן להוסיף אותו חדר לאותה חבילה",
                'roomsByRequestSubjectOfHotelAvailabilityTitle':"הוספת חדר נכשלה",
                "youReachedMaxRooms": "הגעת למספר החדרים המרבי",
                "eventTicketAlreadyAdded": "לא ניתן להוסיף כרטיס מאותו סוג, נא בחר כרטיס מסוג אחר",
                'failedToAddEventTicket':"הוספת כרטיס אירוע נכשלה",
                "attractionAlreadyAdded": "Unable to add the same type of attraction, please select a different type of attraction",
                'failedToAddAttraction':"הוספת אטרקציה נכשלה",
                "adult": "מבוגר",
                "child": "ילד",
                "infant": "תינוק",
                "perPerson": "לאדם",
                "perVehicle": "לכלי",
                "group": "קבוצה",
                "family": "משפחה",
                "perEquipment": "לפי ציוד",
                "perBoat": "פר סירה",
                "none": "לא ידוע",
            },
            "checkout":{
                "fill_out_at_least_one_guest_fields": "אנא מלא את כל השדות לפחות לאורח אחד!",
                "addRestOfGuests": "הזן את כל פרטי הנוסעים",
                "hideRestOfGuests": "הסתר נוסעים",
                "addBaggage":"הוספת כבודה",
                "newGuest":"נוסע חדש",
                "selectGuest":"בחר נוסע",
                "chooseExistingGuest":"בחר נוסע קיים",
                "additionalBaggage":"מטען נוסף",
                "free":"חינם",
                "baggageIsForBothFlights":"הוספת כבודה לטיסה הלוך וחזור יחד",
                "additionalBaggageForThisGuest": 'כבודה נרכשה לנוסע זה בתוספת תשלום',
                "orderFailedToLoad":"התרחשה שגיאה בעת טעינת ההצעה",
                "cartNoLongerValid":"העגלה כבר לא תקפה",
                "room": 'חדר',
                "personalInfo":"פרטי הנופשים",
                "paymentDetails":"פרטי התשלום",
                "orderCompletion":"סיום הזמנה",
                "userDetails":"פרטי המזמין",
                "name":"שם פרטי",
                "lastName":"שם משפחה",
                "passport":"מס׳ דרכון",
                "inEnglish":"באנגלית",
                "birthdate":"תאריך לידה",
                "phone":"טלפון",
                "email":"דוא״ל",
                "notesForTheOrder":"הערות להזמנה",
                "namesOfGuests":"שמות הנוסעים",
                "namesMustMatchPassport":"* יש להקליד את כל השמות באנגלית בדיוק כפי שמופיעים בדרכון",
                "goToPayments":'שליחה ומעבר לתשלום',
                "saveAndCommit": "שמור ואשר להצעה",
                "saveAndPayLater": "שמור ושלם מאוחר יותר",
                "saveOrder":'שמור הזמנה',
                "agreement":"אני מאשר/ת תקנון האתר, תנאי ההזמנה ואת תנאי ביטול ההזמנה",
                "men":"זכר",
                "women":"נקבה",
                "pleaseInputYourPhone":"נא להזין מספר טלפון",
                "pleaseInputYourLastName":"נא להזין שם המשפחה",
                'pleaseInputYourFirstName':"נא להזין את שמך הפרטי",
                "pleaseInputYourEmail":"נא להזין את המייל",
                "pleaseInputYourPassportNumber":"אנא הזן את מספר הדרכון שלך",
                "pleaseInputYourDateOfBirth":"נא להזין תאריך הלידה",
                "pleaseSelectGender":"נא לבחור מין",
                "maxChildAge":"ילד בין הגילאים 2-",
                "maxInfantAge":"תינוקות חייבים להיות מתחת לגיל שנתיים במועד החופשה",
                'pleaseAgreeWithT&C':"נא להסכים לתנאי השימוש ותקנון האתר",
                'viewTerms':"לצפיה בתקנון",
                "invalidEmail":"אימייל שגוי",
                "orderCreateSuccess": "הזמנתך נשמרה בהצלחה, הנך מועבר לתשלום",
                "orderCreateFree": "הזמנתך נשמרה בהצלחה!",
                "orderUpdateSuccess": "הזמנתך עודכנה בהצלחה!",
                "mainRoomGuestTitle" :"חדר על שם",
                "uploadPassportImage":"העלאת צילום דרכון",
                "addInfant":"הוסף תינוק",
                "updateInfant": "עדכון כמות תינוקות",
                "howManyInfantsDoYouWantToAdd":"בחר את כמות התינוקות לחדר זה",
                "add":"לְהוֹסִיף",
                "setInfantCountForRoom": "עדכן כמות תינוקות",
                "setInfantCountForRoomSuccess": "כמות התינוקות עודכנה בהצלחה",
                "infantsAddedToTheRoom":"תינוקות שנוספו לחדר",
                "selectNumberOfInfants":"בחר מספר תינוקות",
                "pricePerInfant":"מחיר לתינוק",
                "infantsRemoved":"הוסרו התינוקות לחדר זה",
                "requiredUploadPassportImage":"חובה להעלאת צילום דרכון",
                "infantError4403":"לא ניתן לשנות כמות תינוקות - צור קשר עם מוקד השירות",
                "docketId":"* Docket ID",
                "agencyId":"* Agency ID",
                "documentType": "סוג מסמך",
                "documentTypeInfo": "בחר תעודת זהות לטיסות פנים",
                "documentTypePassport": "דרכון",
                "documentTypeIdCard": "תעודת זהות",
                "issuingCountry": "מדינת הנפקה",
                "residenceCountry": "מדינת מגורים",
                "nationality": "אזרחות",
                "documentNumber": "מספר מסמך",
                "documentNumberPassport": "מספר דרכון",
                "documentNumberIdCard": "מספר תעודת זהות",
                "pleaseInputPassportNumber": "אנא הזן מספר דרכון",
                "pleaseInputIdCardNumber": "אנא הזן מספר תעודת זהות",
                "expirationDate": "תאריך תפוגה",
                "pleaseSelectDocumentType": "אנא בחר סוג מסמך",
                "pleaseSelectIssuingCountry": "אנא בחר מדינת הנפקה",
                "pleaseSelectResidenceCountry": "אנא בחר מדינת מגורים",
                "pleaseSelectNationality": "אנא בחר אזרחות",
                "pleaseInputDocumentNumber": "אנא הזן מספר מסמך",
                "pleaseSelectExpirationDate": "אנא בחר תאריך תפוגה",
                "noTrolly":"בלי טרולי",
                "noSuitcase":"ללא מזוודה",
                "updateBaggages":"עדכון מזוודות",
                "manageBaggagesFor":"נהל מזוודות עבור אורח",
                "closeAddBaggage":"הסתר אופציות",
                "close":"סגור"
            },
            "manageOrder": {
                "moveToPayment": "הוסף אמצעי תשלום",
                "backToManage": "חזור לניהול הזמנה",
                "paymentTitle": "הוספת אמצעי תשלום",
                "manageTitle": "עדכון פרטי הנופשים",
                "modelNotFound": "הזמנה  לא נמצאה",
                "orderId":"ניהול הזמנה",

                "room_booking_cancelled_successfully": "הזמנת החדר בוטלה בהצלחה",
                "room_booking_cancel_error": "שגיאה בביטול הזמנת החדר",
                "cancel_room_booking_warning": "בביטול החדר תאבד את ההזמנה והמחיר, האם אתה בטוח?",
                "cancel_booking": "בטל הזמנה"
            },
            "completionForm": {
                "paymentFinish": {
                    "title": "ההזמנה בוצעה בהצלחה - התשלום הושלם",
                    "info": "מייל עם פרטי ההזמנה נשלח אליך לכתובת",
                },
                "waitingToApprove": {
                    "title": "ההזמנתך הועברה לאישור",
                    "info1": "פרטי ההזמנה נשמרו במערכת והועברו לאישור.",
                    "info2": 'תשלום התבצע רק לאחר אישור ההזמנה.',
                    "info3": 'מייל עם אישור ההזמנה ותשלום ישלח לאחר אישור ההזמנה.',
                },
                "paymentFail": {
                    "title": "התשלום נכשל",
                    "info1": "התשלום נכשל :(",
                    "infoFail": "לאחר מספר נסיונות, החיוב נכשל - אנה נסה שנית",
                    "infoWhatsapp": "במידה והתרחשה שגיאה, ואינך מצליח לשלם - יש ליצור קשר בוואטסאפ במספד: ",
                },
                "orderNum": "מספר ההזמנה",
                "thanksForChoose": "תודה שבחרת ב",
                "free": {
                    "title": "הרישום בוצע בהצלחה",
                    "info": "נשלח אליך מייל עם סיכום ההזמנה",
                } ,
                "pay_later": {
                    "title": "הרישום בוצע בהצלחה",
                    "info": "נשלח אליך מייל עם אישור ההזמנה",
                }
            },
            "paymentForm": {
                "priceCanNotBeOverBalance":"מחיר לתשלום לא יכול להיות מעל גובה היתרה",
                "total": "סה״כ קישורים לתשלום",
                "balance": "יתרה לתשלום",
                "updatedBalance":"יתרה עדכנית",
                "copyLink":"העתק קישור",
                "linkFor": "קישור עבור",
                "back": "חזרה",
                "createLink": "צור קישור",
                "setSpecificPrice":"יצירת לינק לתשלום",
                "setPriceAndSendPaymentLinkToClient":"הזן סכום לתשלום וצור לינק לתשלום ללקוח",
                "clientName":"שם הלקוח",
                "paymentPageFor":"דף תשלום עבור ",
                "forPayment":"לתשלום",
                "price":"מְחִיר",
                "copyPaymentLink":"העתק קישור לתשלום",
                "pleaseFillInBothFields":"נא למלא את שני השדות.",
                "paymentLinkCopiedToClipboard":"קישור התשלום הועתק ללוח!",
                "createLinkForPrice":"צור לינק לתשלום",
                "creditNotSaveInBd": " פרטי האשראי אינם נשמרים האתר - הינך משלים תשלום בדרך מאובטחת",
                "title": "הזן אמצעי תשלום",
                "splitBtn": "לחץ לפיצול כרטיסי אשראי",
                "splitTitle": "פיצול כרטיסי אשראי",
                "splitDesc": "בחר את הכמות כרטיסי אשראי לפיצול ולחץ אישור",
                "noSplit": "ללא פיצול",
                "noPayments": "ללא תשלומים",
                "payments": "תשלומים",
                "paymentsNum": "מספר תשלומים",
                "withDebit": "עם קרדיט",
                "splitBy": "כרטיסי אשראי",
                "toPay": "לתשלום",
                "splitApprove": "אישור",
                "currencyRate": " חיוב מתבצע בשקלים - לפי שער תיירות",
                "splitCurrentCardNum": "פיצול אשראי",
                "errorMessageToRetry": "נסיון מס׳ {retryNum} - תשלום נכשל מול מחברת האשראי, יש להזין שוב את פרטי כרטיס אשראי או כרטיס אחר. אתר מקבל כרטיס VISA ו MASTERCARD בלבד.",
                "splitCurrentCardNumFrom": "מתוך",
            },
            "hotelTypes": {
                "Hotel": "מלון",
                "Apartment": "דירות",
                "Apart-hotel": "מלון דירות",
                "Guesthouse": "בית הארחה",
                "Resort": "ריזורט",
                "Boutique_and_Design": "מלון בוטיק",
            },
            "hotelDetails":{
                "updateDates":"עדכון תאריכים",
                "roomTypesToChooseFrom":"סוגי חדרים לבחירתך",

                "metapolicy": "מדיניות המלון",
                "metaExtraInfo": "פרטים נוספים",
                "not_included": "לא כלול",
                "included": "כלול",
                "price": "בעלות של",
                "address": "כתובת",
                "other": "כתובת",
                "Location": "מיקום מלון",
                "At the boutique hotel ": "על המלון",
                "Room amenities": "שירות חדרים",

                "parking": "חניה",
                "pets": "חיות מחמד",
                "shuttle": "הסעה לשדה (לכיוון)",
                "internet": "שירותי אינטרנט",
                "extra_bed": "מיטה נוספת",
                "add_fee": "תוספת תשלום",
                "children_meal": "ארוחת ילדים",
                "check_in_check_out": "צ׳ק אין וצ׳ק אווט",

            },
            "sideFilters": {
                "sortBy": "מיון לפי",
                "price_asc": "מחיר נמוך ביותר",
                "price_desc": "מחיר גבוה ביותר",
                "hotel_stars_asc": "כוכבי מלון נמוכים ביותר",
                "hotel_stars_desc": "כוכבי מלון גבוהים ביותר",
                "recommended": "מומלץ ביותר",
                "price": "מחיר",
                "clearSideFilters":"ניקוי מסננים",
                "ts_type": "סוגי טיסות",
                "auto_approve": "אישור מידי",
                "include_transfer": "כולל העברות",
                "include_baggage": "כולל מזוודה",
                "include_trolly": "כולל טרולי",
                "auto_approve_checked": "הצגת תוצאות אישור מידי",
                "from_date_hours": "שעת טיסה הלוך",
                "return_date_hours": "שעת טיסה חזור",
                "isSpecial": "האם מיוחד?",
                "is_special": "האם מיוחד?",
                "date_range": "טווח תאריכים",
                "from_date_landing_hours": "שעת טיסה הלוך",
                "flight_stop_time": "שעת עצירה",
                "return_date_landing_hours": "שעת טיסה חזור",
                "airline": "חברת תעופה",
                "2": "טיסות שכר",
                "3": "טיסות סדירות",
                "nonStop": "טיסה ישירה",
                "stop": "עצירה אחת",
                "stops_plural": "עצירות",
                "hotel_type": "סוגי אירוח",
                "stops": "מס׳ עצירות",
                "freeCancellation": "ביטול חינם?",
                "freeCancellationLabels": {
                    "1": "ביטול חינם בלבד",
                    "0": "ללא ביטול חינם",
                },

                "feature": "מאפיינים",

                "event_type": "סוגי אירועים",
                "avenue": "שדרה",
                "event_date": "תאריך אירוע",
            },
            "package_feature": {
                "SPECIAL PACKAGE": "חבילות מיוחדות",
                "ALL PACKAGES": "כל החבילות",
                "KOSHER": "מותאם כשר",
                // "TOUR": "סיור",
                "TOUR": "טיולים מאורגנים",
                "SKI": "סקי",
                "EVENT": "אירוע",
                "SPORT": "ספורט",
                "SPA": "ספא",
                "YOUNG VACATION": "חופשה לצעירים",
                "FLT+HTL+CAR": "טיסה+מלון+רכב"
            },
            "hotelAmenities": {
                // "dummy": "dummy"
            },
            "general":{
                "toOrder": "לצורת בקשה",
                "amount": "סכום",
                parentOriginal: "מקור מהורה",
                parentEdited: "עריכה מהורה",
                "fetchingMoreResults": "טוען תוצאות נוספות...",
                "refresh": "רענן",
                "list": "רשימה",
                "matched": "מתאים",
                "rates": "מחירים",
                "calculatedRates": "מחירים מחושבים",
                "totalPrice": "מחיר כולל",
                "selected": "בחרת",
                "to": "ל",
                "roomOnly": 'למלון בלבד',
                "close": "סגור",
                "remark": "הערה",
                "addService": "הוסף שירות",
                "orgInfo": "מסלול",
                "tourInfo": "פרטי הטיול",
                packagesMainTitle: "חבילות נופש",
                vacationAtHeader: "חופשה ב",
                daysOfStay: "תאריכים",
                additionalFlights: "טיסות נוספות",
                flightsPromoTitle: "טיסות האחרון",
                lowPrice:"מחיר נמוך",
                flightUpTo: "טיסה מ",
                "additionalPackages": "חבילות נוספות",
                "packagePlan": "חבילות נופש מ",
                "immediateApproval": "אישור מיידי",
                "attraction":"אטרקציה",
                "includeReturnSuitcase":"כבודה כולל טיסה חזור",
                "base": "בסיס",
                "total": "סה״כ",
                "as_of_today": "נכון להיום",
                "link_to_the_offer": "לינק להצעה ",
                "the_quote_has_been_copied_successfully": "'הצעת המחיר הועתקה בהצלחה",
                "submit": "חפש",
                "sort": "סנן",
                "recommended": "מומלץ ביותר",
                "maxAmountOf": "כמות מקסימלית של",
                "minAmountOf": "כמות מינימלית של",
                "ticketType": "סוג כרטיס",
                "timeSlot": "בחר זמן",
                "language": "שפה",
                "cancellation_policy": "מדיניות ביטולים",
                "additionalInfo": "מידע נוסף",
                "hour": "שעה",
                "minute": "דקה",
                "before": "לפני",
                "date": "תאריך",
                "duration": "משך זמן",
                "quantity": "כמות",
                "for":"עבור",
                "free":"חינם",
                "freeOfCharge": "ללא תשלום",
                'option': 'אופציה',
                'removeSelection': "הסר בחירה",
                'grandTotalPrice': 'מחיר כולל',
                'startingPrice': "מחיר התחלתי",
                "usd": "USD",
                "euro": "EURO",
                "availableSeats":"מקומות פנויים",
                "showGrossPrice":"הצג מחיר ברוטו",
                "showNetPrice":"הצג מחיר נטו",
                "noRating": "ללא דירוג",
                "address": "כתובת",
                "type": "סוג",
                "boardBasis":"בסיס אירוח",
                "supplier":"ספק",
                "airLine":"חברת תעופה",
                "price":"מחיר",
                "totalRoomPrice": "סה״כ מחיר לחדר",
                "priceForXRooms": "מחיר ל X חדרים",
                "hotel":"מלון",
                "hotel_stars":"כוכבי מלון",
                "minPrice":"החל מ",
                "BB":"ארוחת בוקר כלולה",
                "HB":"חצי פנסיון",
                "cancel":"ביטול",
                "replaceShoppingCart":"עגלת קניות לא נשמרת האם ברצונך להחליף אותה",
                "replace":"החלף",
                "searchForUser":"חפש לקוח לפי שם או טלפון",
                "fieldRequired":"שדה נדרש",
                "bundleFlight":"טיסה הלוך ושוב",
                "trollyIsIncluded":"טרולי כלול",
                "trollyIsNotIncluded":"ללא טרולי",
                "suitcaseIsIncluded":"מזוודה כלולה",
                "suitcaseIsNotIncluded":"ללא מזוודה",
                "additionalSuitcases":"כולל X מזוודות",
                "additionalTrolly":"כולל X טרולי",
                "returnFlight":"טיסה חזור",
                "outboundFlight":"טיסה הלוך",
                "agentMode":"מצב סוכן",
                "userMode":"מצב משתמש",
                "suitcase":"מזוודה",
                'trolly':"טרולי",
                "packageSearchResult":"החבילות שמצאנו עבורך",
                "day":"יום",
                "selectDate":"בחרו תאריכים",
                "search":"חיפוש",
                "adults":"מבוגרים",
                "adult":"מבוגר",
                "child":"ילד",
                "children":"ילדים",
                "infant":"תינוק",
                "infants":"תינוקות",
                "noResults":"אין תוצאות",
                "nights":"לילות",
                "includesActivities":"{NUMBER} אטרקציות מתנה!",
                "includesActivity":"כולל אטרקציה מתנה!",
                "all_include": "הכל כלול",
                "breakfast":"ארוחת בוקר",
                "half_board":"חצי פנסיון",
                "half_board_kosher":"חצי פנסיון כשר",
                "full_board" : "פנסיון מלא",
                "sleep_only" : "לינה בלבד",
                "breakfast_kidush" : "א.בוקר וא.ערב שישי",
                "addToCard": "הוסיפו להזמנה",
                "chooseRoom": "בחרו סוג חדר",
                "boardType":"בסיס לינה",
                "filters":"מסננים",
                "rating":"דירוג מלון",
                "attraction_stars": "דירוג אטרקציה",
                "name": "שם",
                "taxonomies": "טקסונומיות",
                "toDate" : "עד",
                "transfers" : "העברות",
                "from" : "החל מ-",
                "perPerson" : "לאדם",
                "perPax": "ליחידה",
                "include" : "כולל",
                "noIncludeText" : "חבילות נופש",
                "flights" : "טיסות",
                "flight" : "טיסה",
                "vacationAt": "חופשה ב{DEST}",
                "showAll":"הצג הכול",
                "showLess":"הצג פחות",
                "h": " ש׳",
                "min": " ד׳",
                "acceptCookiesTitle":"אתר זה משתמש בקובצי Cookie. על-ידי שימוש באתר ובשירות שלנו אתה מסכים עם מדיניות השימוש שלנו בקובצי Cookie, כמתואר בתקנון האתר.",
                "acceptCookiesBtn":"קבל",

                "loading": "טוען",
                "showingMoreResults": "מציג תוצאות נוספות",
                "noMoreResults": "אין עוד תוצאות",
                "NoResultsMatchedTheFilterValues": "לא נמצאו תוצאות התואמות לערכי הסינון",
                "selectDestination": "בחר יעד או מלון לחיפוש"
            },
            "subsidizedForm":{
                "title":"הוספת סבסוד",
                "employee_id":"מספר עובד",
                "person_id":"ת.ז (9 ספרות)",
                "validate":"בדוק קוד עובד",
                "alreadyApplied":"הסבסוד כבר חל",
                "addOneMore":"הוסף סבסוד נוסף",
                "addOneMoreId":"הוסף עובד נוסף",
                "fieldRequired":"שדה חובה",
                "priceReducedBy":"מחיר מופחת ב",
                "forEmployee":"עבור עובד",
                "employeeIs":"זוהה בהצלחה ",
                "error4401":'נכשל בזיהוי, נסה שנית',
                "error4402":'קוד זוהה, אך כבר בשימוש',
                "guestIdentifiedId": 'מזוהה לפי ת.ז',
                "guestNotIdentified": 'יש להזדהות לפני רישום',
                "clickToIdentify":"לחץ להזדהות"
            },
            "uploadImage":{
                "uploadPassportImage":"העלאת צילום דרכון",
                "somethingWentWrong":"Something went wrong"
            },
            "flightButton":{
                "no_availability_for_this_flight_price": "מצטערים, אבל אין עוד זמינות לתמחור הטיסה הזה",
                "flightTotalPrice":"מחיר טיסה לכיוון",
                "total":"",
                "continueToOrder":"מעבר להזמנה",
                "addToCart":"הוסף לסל",
                "lastPlace":"מקומות אחרונים",
                "pricePerPassenger":"מחיר לנוסע",
                "cardConditions": "תנאי כרטיס",
            },
            "agentCommission":{
                'supplier':"ספק",
                'commission':"עמלה",
                "netPrice":"מחיר נטו",
                "recommendedFee":"עמלה",
                "transactionDetailsForAgent":"פרטי עסקה לסוכן",
                "supplierNotes":"הערות ספק",
                "cancellationConditions":"ותנאי ביטול",
                "addToCartToChangeFree":"הוסף לסל לשינוי עמלה",
                "pricesShownAreNetPrices":"המחירים המוצגים הינם מחירי נטו",
                "pricesShownAreGrossPrices":"המחירים המוצגים הם מחירים ברוטו",
                "packageRemarks": "הערות לחבילה",
            },
            "support": {
                "contactSupport": "צור קשר עם התמיכה",
                "submitTicket": "פתח פנייה",
                "myTickets": "הפניות שלי",
                "viewMyTickets": "צפה בפניות שלי",
                "selectCategory": "בחר קטגוריה",
                "selectReason": "בחר סיבה",
                "linkOrder": "קשר להזמנה (אופציונלי)",
                "describeIssue": "תאר את הבעיה",
                "review": "סקירה ושליחה",
                "categoryFlights": "טיסות",
                "categoryHotels": "מלונות",
                "categoryPackages": "חבילות",
                "categoryBilling": "חיוב ותשלומים",
                "categoryTechnical": "תמיכה טכנית",
                "categoryOther": "אחר",
                "reasonBookingIssue": "בעיית הזמנה",
                "reasonFlightCancellation": "ביטול טיסה",
                "reasonFlightChange": "שינוי טיסה",
                "reasonSeatSelection": "בחירת מושב",
                "reasonBaggageIssue": "בעיית מטען",
                "reasonRefundRequest": "בקשת החזר",
                "reasonOther": "אחר",
                "reasonReservationChange": "שינוי הזמנה",
                "reasonRoomUpgrade": "שדרוג חדר",
                "reasonCancellationRequest": "בקשת ביטול",
                "reasonAmenitiesQuestion": "שאלה על שירותים",
                "reasonAddServices": "הוספת שירותים",
                "reasonPackageModification": "שינוי חבילה",
                "reasonItineraryQuestion": "שאלה על מסלול",
                "reasonPaymentFailed": "תשלום נכשל",
                "reasonRefundStatus": "סטטוס החזר",
                "reasonInvoiceRequest": "בקשת חשבונית",
                "reasonPricingQuestion": "שאלת תמחור",
                "reasonPaymentMethod": "אמצעי תשלום",
                "reasonLoginProblem": "בעיית התחברות",
                "reasonWebsiteError": "שגיאת אתר",
                "reasonMobileAppIssue": "בעיה באפליקציה",
                "reasonPaymentGateway": "שער תשלום",
                "reasonGeneralInquiry": "פנייה כללית",
                "reasonFeedback": "משוב",
                "reasonComplaint": "תלונה",
                "reasonSuggestion": "הצעה",
                "fullName": "שם מלא",
                "fullNamePlaceholder": "הזן את שמך המלא",
                "email": "אימייל",
                "emailPlaceholder": "your.email@example.com",
                "phone": "טלפון (אופציונלי)",
                "phonePlaceholder": "+ 972 -",
                "subject": "נושא",
                "subjectPlaceholder": "תיאור קצר של הבעיה",
                "priority": "עדיפות",
                "priorityLow": "נמוכה",
                "priorityMedium": "בינונית",
                "priorityHigh": "גבוהה",
                "priorityUrgent": "דחופה",
                "description": "תיאור מפורט",
                "descriptionPlaceholder": "אנא ספק פרטים רבים ככל האפשר על הבעיה...",
                "attachments": "קבצים מצורפים",
                "attachmentsHint": "ניתן לצרף עד 5 קבצים (מקסימום 2MB כל אחד)",
                "selectOrder": "בחר הזמנה קשורה",
                "searchOrders": "חפש הזמנות לפי יעד, תאריכים או מספר הזמנה...",
                "noOrders": "לא נמצאו הזמנות",
                "manualOrderId": "הזן את מספר ההזמנה שלך:",
                "orderIdPlaceholder": "לדוגמה: 12345",
                "signedInAs": "מחובר כ",
                "guestUser": "משתמש אורח",
                "requiredForGuests": "נדרש לשליחה",
                "consentLabel": "אני מסכים לתנאים וההגבלות",
                "consentText": "בשליחת פנייה זו, אני מאשר שהמידע שסופק מדויק ואני מסכים לעיבוד הנתונים האישיים שלי על ידי Sky Group לצורך פתרון הפנייה.",
                "next": "הבא",
                "back": "חזור",
                "submit": "שלח פנייה",
                "cancel": "ביטול",
                "addFile": "הוסף קובץ",
                "removeFile": "הסר",
                "selectFile": "בחר קבצים",
                "required": "שדה חובה",
                "invalidEmail": "אנא הזן כתובת אימייל תקינה",
                "selectCategoryRequired": "אנא בחר קטגוריה",
                "selectReasonRequired": "אנא בחר סיבה",
                "descriptionTooShort": "אנא ספק פרטים נוספים (מינימום 20 תווים)",
                "fileTooLarge": "גודל הקובץ עולה על 2MB",
                "tooManyFiles": "מקסימום 5 קבצים מותרים",
                "invalidFileType": "סוג קובץ לא נתמך",
                "consentRequired": "עליך להסכים לתנאים כדי לשלוח",
                "successTitle": "הפנייה נשלחה בהצלחה!",
                "successMessage": "פנייתך נוצרה. נבדוק אותה בקרוב ונחזור אליך.",
                "ticketNumber": "מספר פנייה",
                "nextSteps": "מה קורה הלאה?",
                "nextStepsText": "צוות התמיכה שלנו יבדוק את הפנייה ויגיב תוך 24-48 שעות. תקבל עדכונים באימייל ל",
                "emailConfirmation": "אימייל אישור נשלח לתיבת הדואר שלך.",
                "ticketId": "פנייה",
                "status": "סטטוס",
                "category": "קטגוריה",
                "lastUpdated": "עדכון אחרון",
                "created": "נוצר",
                "open": "פתוח",
                "pending": "ממתין",
                "resolved": "נפתר",
                "closed": "סגור",
                "noTickets": "לא נמצאו פניות תמיכה",
                "noTicketsMessage": "עדיין לא שלחת פניות תמיכה.",
                "orderNumber": "הזמנה",
                "orderDestination": "יעד",
                "orderDates": "תאריכי נסיעה",
                "orderAmount": "סכום",
                "orderStatus": "סטטוס",
                "priorityP1": "קריטי",
                "priorityP2": "גבוה",
                "priorityP3": "בינוני",
                "priorityP4": "נמוך",
                "errorSubmitting": "שליחת הפנייה נכשלה. אנא נסה שוב.",
                "errorLoadingOrders": "טעינת הזמנות נכשלה.",
                "networkError": "שגיאת רשת. אנא בדוק את החיבור שלך.",
                "needHelp": "צריך עזרה?",
            },
            "blog": {
                "home": "בית",
                "blog": "בלוג",
                "categories": "קטגוריות",
                "articles": "מאמרים",
                "articlesIn": "מאמרים ב",
                "latestTravelStories": "סיפורי הטיול האחרונים",
                "discoverInspiring": "גלו יעדים מעוררי השראה וטיפים מומחים לטיולים",
                "viewAllArticles": "צפו בכל המאמרים",
                "readMore": "קרא עוד",
                "minRead": "דקות קריאה",
                "addBookmark": "הוסף לסימניות",
                "removeBookmark": "הסר מהסימניות",
                "shareThisArticle": "שתפו את המאמר",
                "shareThisCategory": "שתפו קטגוריה זו",
                "shareWithFriendsAndFamily": "שתפו את המאמרים האהובים עליכם עם חברים ומשפחה",
                "share": "שתף",
                "shareOnFacebook": "שתף בפייסבוק",
                "shareOnTwitter": "שתף בטוויטר",
                "shareOnLinkedIn": "שתף בלינקדאין",
                "shareOnPinterest": "שתף בפינטרסט",
                "shareOnInstagram": "שתף באינסטגרם",
                "copyLink": "העתק קישור",
                "linkCopied": "הקישור הועתק!",
                "copied": "הועתק!",
                "copyFailed": "העתקת הקישור נכשלה",
                "followUs": "עקבו אחרינו",
                "instagram": "אינסטגרם",
                "facebook": "פייסבוק",
                "twitter": "טוויטר",
                "relatedArticles": "מאמרים קשורים",
                "noPostsFound": "לא נמצאו פוסטים בקטגוריה זו",
                "postNotFound": "הפוסט לא נמצא",
                "showing": "מציג",
                "sortBy": "מיון לפי:",
                "newestFirst": "החדש ביותר",
                "alphabetical": "א-ת",
                "gridView": "תצוגת רשת",
                "listView": "תצוגת רשימה",
                "exploreMoreCategories": "גלו עוד קטגוריות",
                "travelInspiration": "השראה לטיולים",
                "getWeeklyGuides": "גלו אתרי סוד וטיפים בלעדיים לטיולים שנאספו למגיעים כמוכם",
                "bookYourFlight": "הזמינו את הטיסה שלכם",
                "facebookShare": "Facebook",
                "twitterShare": "Twitter",
                "instagramShare": "Instagram",
                "linkedinShare": "LinkedIn",
                "whatsappShare": "WhatsApp",
                "pinterestShare": "Pinterest",
                "shareArticle": "שתפו את המאמר",
                "shareCategory": "שתפו קטגוריה",
            }
        }
    }
};

export default translations;